/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const uri = "api/wes/TrainingCalendar/GetEvents";


export interface Pagination {
    CurrentPage: number
    Page: number
    PageSize: number
    DefaultPageSize: number
    TotalItemCount: number
    NumberOfPages: number
    PageSizeOptions: number[]
  }
export interface GetEventsApiParameter extends ApiParameter, HasPagingParameters {
    Topic?: string;
    Locations?: string;
    Price?: string;
    Credits?: string;
    Duration?: string;
    SearchQuery?: string;
}

export interface EventModel {
    Title: string;
    Url: string;
    DisplayRegisterCta: boolean;
    Topic: string;
    Tags: string[];
    ShortDescription: string;
    DurationDescription: string;
    PriceDescription: string;
    Locations: string[];
    CreditsDescription: string;
    Pdf: string;
}

export interface TrainingFacetValue {
    AdditionalInfo: string;
    Description: string;
    Id: string;
    Name: string;
}

export interface ModifiedTrainingFacetValue extends TrainingFacetValue {
    parent: string;
}

export interface TrainingFacetsModel {
    Description: string;
    Id: string;
    Name: string;
    Values: TrainingFacetValue[];
}

export interface EventsCollectionModel extends BaseModel {
    Events: EventModel[] | null;
    Facets: TrainingFacetsModel[];
    Pagination: Pagination | null;
}

export async function getEvents(parameter: GetEventsApiParameter) {
    const data = await get<EventsCollectionModel>(uri, parameter);
    return data;
}
